<script type="text/jsx">
import { noop } from 'lodash';

export default {
  name: 'PhoneSelectFooter',
  props: {
    disabledSave: Boolean,
    onSave: {
      type: Function,
      default: noop,
    },
    onCancel: {
      type: Function,
      default: noop,
    },
    saveText: {
      type: String,
    },
    cancelText: {
      type: String,
    },
  },
  methods: {
    mx_renderSave() {
      return <zm-button round type="primary" onClick={this.onSave} disabled={this.disabledSave}>
        {this.saveText || this.$t('common.btn_save')}
      </zm-button>;
    },
    mx_renderCancel() {
      return <zm-button round onClick={this.onCancel}>
        {this.cancelText || this.$t('common.btn_cancel')}
      </zm-button>;
    },
  },
  render() {
    const saveVNode = this.mx_renderSave();
    const cancelVNode = this.mx_renderCancel();

    return <div class="phone-number-select__footer">
      {this.$context.is.mobile ? [cancelVNode, saveVNode] : [saveVNode, cancelVNode]}
    </div>;
  },
};
</script>

<style lang="scss">
@import '@/styles/responsive.scss';

@include media(mobile) {
  .phone-number-select {
    &__footer {
      position: fixed !important;
      z-index: 10;
      .zm-button.is-round {
        height: 40px;
        font-size: 16px;
      }
    }
  }
}

@include media(tablet) {
  .phone-number-select {
    &__footer {
      background: white;
      transform: translateX(-24px);
      border-radius: 0 0 10px 10px;
    }
  }
}
</style>
